import React, { useEffect, useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import api from '../service/api';

export function telecallerAreaDisplay(user) {
  if (!user || user.role !== 'telecaller') {
    return { assembly: '—', ward: '—', booth: '—' };
  }
  if (user.assignedBooth) {
    return { assembly: '—', ward: '—', booth: user.assignedBooth };
  }
  if (user.assignedWardNo) {
    return { assembly: '—', ward: user.assignedWardNo, booth: 'All' };
  }
  if (user.assignedWard) {
    return { assembly: user.assignedWard, ward: 'All', booth: 'All' };
  }
  return { assembly: '—', ward: '—', booth: '—' };
}

const AssignmentAreaSelects = ({
  value,
  onChange,
  selectClassName = 'form-select bg-white border shadow-none rounded-3 py-2',
  selectStyle,
  labelClassName = 'small fw-bold text-slate-500 mb-1',
  grouped = true
}) => {
  const assignedWard = value?.assignedWard || '';
  const assignedWardNo = value?.assignedWardNo || '';
  const assignedBooth = value?.assignedBooth || '';

  const [assemblies, setAssemblies] = useState([]);
  const [wards, setWards] = useState([]);
  const [booths, setBooths] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await api.get('/api/admin/assignment-options', {
          params: {
            acNo: assignedWard || undefined,
            ward: assignedWardNo || undefined
          }
        });
        setAssemblies(res.data.assemblies || []);
        setWards(res.data.wards || []);
        setBooths(res.data.booths || []);
      } catch (error) {
        console.error('Failed to load assignment options:', error);
      }
    };
    load();
  }, [assignedWard, assignedWardNo]);

  const handleChange = (event) => {
    const { name, value: next } = event.target;
    if (name === 'assignedWard') {
      onChange({ assignedWard: next, assignedWardNo: '', assignedBooth: '' });
      return;
    }
    if (name === 'assignedWardNo') {
      onChange({ assignedWard: '', assignedWardNo: next, assignedBooth: '' });
      return;
    }
    onChange({ assignedWard: '', assignedWardNo: '', assignedBooth: next });
  };

  const wardBlankLabel = assignedWard ? 'All' : '—';
  const boothBlankLabel = assignedWard || assignedWardNo ? 'All' : '—';

  const fields = (
    <Row className="g-3">
      <Col xs={12} md={4}>
        <Form.Group>
          <Form.Label className={labelClassName}>Assembly</Form.Label>
          <Form.Select
            name="assignedWard"
            value={assignedWard}
            onChange={handleChange}
            className={selectClassName}
            style={selectStyle}
          >
            <option value="">—</option>
            {assemblies.map((item) => (
              <option key={item} value={item}>{item}</option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
      <Col xs={12} md={4}>
        <Form.Group>
          <Form.Label className={labelClassName}>Ward</Form.Label>
          <Form.Select
            name="assignedWardNo"
            value={assignedWardNo}
            onChange={handleChange}
            className={selectClassName}
            style={selectStyle}
          >
            <option value="">{wardBlankLabel}</option>
            {wards.map((item) => (
              <option key={item} value={item}>{item}</option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
      <Col xs={12} md={4}>
        <Form.Group>
          <Form.Label className={labelClassName}>Booth</Form.Label>
          <Form.Select
            name="assignedBooth"
            value={assignedBooth}
            onChange={handleChange}
            className={selectClassName}
            style={selectStyle}
          >
            <option value="">{boothBlankLabel}</option>
            {booths.map((item) => (
              <option key={item} value={item}>{item}</option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
    </Row>
  );

  if (!grouped) {
    return fields;
  }

  return (
    <div className="rounded-4 border p-3" style={{ background: '#f8fafc', borderColor: '#e2e8f0' }}>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div>
          <div className="fw-bold text-dark small">Call area</div>
          <div className="text-secondary" style={{ fontSize: '0.75rem' }}>
            Assembly = that assembly, all wards, all booths. A specific booth stores only the booth.
          </div>
        </div>
      </div>
      {fields}
    </div>
  );
};

export default AssignmentAreaSelects;
